import { useState } from 'react';

const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 500,
  display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)'
};
const boxStyle = {
  background: 'var(--surface)', border: '1px solid var(--border)', width: 480, maxWidth: '90vw',
  clipPath: 'polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px))'
};
const headerStyle = {
  padding: '16px 20px', borderBottom: '1px solid var(--border)',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center'
};
const titleStyle = { fontFamily: 'var(--mono)', fontSize: 13, letterSpacing: 1, textTransform: 'uppercase' };
const closeBtnStyle = { background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 };

// Modal de solo lectura con scroll — para mostrar comandos, mensajes de error, etc.
export function InfoModal({ title, content, onClose }) {
  return (
    <div onClick={onClose} style={overlayStyle}>
      <div onClick={e => e.stopPropagation()} style={boxStyle}>
        <div style={headerStyle}>
          <span style={titleStyle}>{title}</span>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>
        <div style={{ padding: 20 }}>
          <pre style={{
            background: 'var(--bg)', border: '1px solid var(--border)', padding: 16,
            fontFamily: 'var(--mono)', fontSize: 12, color: 'var(--text)',
            overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all',
            maxHeight: 320, overflowY: 'auto', margin: 0
          }}>{content}</pre>
          <button onClick={() => { navigator.clipboard.writeText(content); }}
            style={{ marginTop: 12, background: 'transparent', border: '1px solid var(--accent)', color: 'var(--accent)', padding: '7px 16px', fontSize: 11, fontFamily: 'var(--mono)', cursor: 'pointer', letterSpacing: 1 }}>
            COPIAR
          </button>
        </div>
      </div>
    </div>
  );
}

// Modal de confirmación con variante danger (rojo) para acciones destructivas
export function ConfirmModal({ title, message, onConfirm, onCancel, danger = false, confirmLabel = 'CONFIRMAR' }) {
  return (
    <div style={overlayStyle}>
      <div style={boxStyle}>
        <div style={headerStyle}>
          <span style={{ ...titleStyle, color: danger ? 'var(--red)' : 'var(--text)' }}>{title}</span>
          <button onClick={onCancel} style={closeBtnStyle}>✕</button>
        </div>
        <div style={{ padding: 20 }}>
          <p style={{ fontSize: 13, color: 'var(--muted)', margin: '0 0 20px' }}>{message}</p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={onCancel} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--muted)', padding: '8px 18px', fontSize: 12, fontFamily: 'var(--mono)', cursor: 'pointer' }}>
              CANCELAR
            </button>
            <button onClick={onConfirm} style={{ background: danger ? 'var(--red)' : 'var(--accent)', border: 'none', color: 'var(--bg)', padding: '8px 18px', fontSize: 12, fontFamily: 'var(--mono)', cursor: 'pointer', fontWeight: 700 }}>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Baja lógica de un servidor (DELETE /api/servers/{id}). NO es la eliminación
// definitiva: los datos se conservan 90 días y el servidor se puede reactivar.
export function DeactivateServerModal({ hostname, onConfirm, onCancel }) {
  return (
    <ConfirmModal
      title="Dar de baja el servidor"
      message={`¿Dar de baja el servidor ${hostname}? Sus backups se detienen. Los datos ya respaldados se conservan 90 días y después se borran definitivamente; mientras tanto, OpenBackup puede reactivarlo. El agente sigue instalado en el equipo: desinstalalo con el script de desinstalación (Anexo A.8 del Manual de Usuario).`}
      confirmLabel="DAR DE BAJA"
      danger
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}

